import { Component, inject, OnInit } from '@angular/core';
import { ParentItemProviderService } from '@app/shared';
import {
  ItemInfo,
  NtapCommonComponent,
  NtapGlobalConstants,
  UIComponents,
  ViewState
} from '@ntap/core';
import { tap } from 'rxjs';

@Component({
  selector: 'app-predmeti-restauracije',
  templateUrl: './predmeti-restauracije.component.html',
  styleUrls: ['./predmeti-restauracije.component.scss']
})
export class PredmetiRestauracijeComponent
  extends NtapCommonComponent
  implements OnInit
{
  private parentItemProvider = inject(ParentItemProviderService);

  jediniceURestauracijiViewName: string;
  pojavniObliciURestauracijiViewName: string;
  fizickiObjektiURestauracijiViewName: string;

  jediniceURestauracijiViewStateFilter: ViewState;
  pojavniObliciURestauracijiViewStateFilter: ViewState;
  fizickiObjektiURestauracijiViewStateFilter: ViewState;

  jediniceURestauracijiViewState: ViewState;
  pojavniObliciURestauracijiViewState: ViewState;
  fizickiObjektiURestauracijiViewState: ViewState;

  LIST_COMP_ID = UIComponents.LISTVIEW;

  ngOnInit(): void {
    this.addSubscription(
      this.parentItemProvider.parentItem$
        .pipe(
          tap((parent) => {
            const parentItem = new ItemInfo(parent);

            this.jediniceURestauracijiViewName =
              'jedinice_restauratorskog_plana';
            this.pojavniObliciURestauracijiViewName =
              'pojavni_oblici_restauratorskog_plana';
            this.fizickiObjektiURestauracijiViewName =
              'fizicki_objekti_restauratorskog_plana';

            this.jediniceURestauracijiViewStateFilter = {};
            this.pojavniObliciURestauracijiViewStateFilter = {};
            this.fizickiObjektiURestauracijiViewStateFilter = {};

            this.jediniceURestauracijiViewState = {
              [NtapGlobalConstants.ATTR_$parentId]: parentItem.id,
              [NtapGlobalConstants.ATTR_$parentType]: parentItem.itemType
            };
            this.pojavniObliciURestauracijiViewState = {
              [NtapGlobalConstants.ATTR_$parentId]: parentItem.id,
              [NtapGlobalConstants.ATTR_$parentType]: parentItem.itemType
            };
            this.fizickiObjektiURestauracijiViewState = {
              [NtapGlobalConstants.ATTR_$parentId]: parentItem.id,
              [NtapGlobalConstants.ATTR_$parentType]: parentItem.itemType
            };
          })
        )
        .subscribe()
    );
  }
}
